module.exports = __webpack_public_path__ + "static/media/download.fba82144.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/reports/assets/toolbar/download.svg
// module id = 293
// module chunks = 0